import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import ReactSelect from "react-select";

var CurrentUser = require("lib/account/CurrentUser");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

var LoadingButton = require("components/utility/LoadingButton");
var PaginationControls = require("components/utility/PaginationControls");
var Spinner = require("components/utility/Spinner");

require("users/shared/merge_users_form.scss");

function selectUsers(state, props, grabDuplicates) {
  var { duplicateUserIDs, userIDs, mergeType } = props

  var userIDs = grabDuplicates ? duplicateUserIDs : userIDs

  if (mergeType == ADMIN_MERGE_TYPE) {
    return RosterSelectors.admins({ state, conditions: { ids: userIDs } })
  } else if (mergeType == CLEVER_MERGE_TYPE) {
    if (grabDuplicates) {
      var admins = RosterSelectors.admins({ state, conditions: { ids: userIDs } })
      var students = _.compact(_.uniq(_.flatten(_.map(admins, (admin) => { return _.pluck(admin.all_student_lists, 'students') }))))

      return admins.concat(students)
    } else {
      return props.cleverUsers
    }

  } else {
    return RosterSelectors.students({ state, conditions: { ids: userIDs } })
  }
}

function fetchUsers(props, grabDuplicates) {
  var { duplicateUserIDs, userIDs, mergeType } = props

  var userIDs = grabDuplicates ? duplicateUserIDs : userIDs

  if (mergeType == ADMIN_MERGE_TYPE || mergeType == CLEVER_MERGE_TYPE) {
    var embeds = ["admin.all_student_lists", "student_list.students", "admin.related_users", "user.clever_link_suggestion"]
    return RosterActions.fetchAdmins({ filters: { ids: userIDs }, embeds })
  } else {
    var embeds = ['user.link_suggestion', "user.link_suggestions", "student.password", "student.sso_data"].concat(RosterActions.GLOBAL_STUDENT_EMBEDS)
    return RosterActions.fetchStudents({ conditions: { userIDs }, embeds })
  }
}

@connect(
  (state, props) => ({
    users: selectUsers(state, props, false),
    duplicateUsers: selectUsers(state, props, true)
  }),
  (dispatch, props) => ({
    populateData: () => {
      var users = dispatch(fetchUsers(props, false));
      var dupUsers = dispatch(fetchUsers(props, true));

      var promises = [users, dupUsers]

      if (props.mergeType !== CLEVER_MERGE_TYPE) {
        var conditions = CurrentUser.get().is_wizard ? { slIDs: props.studentListIDs } : {}
        var studentLists = dispatch(RosterActions.fetchStudentLists({
          conditions, embeds: ["student_list.admins", "student_list.students", "student_list.primary_admin", "student.primary_student_list_id"]
        }))
        promises = promises.concat(studentLists)
      }

      return Promise.all(promises);
    },
    mergeUsers: (params) => {
      return dispatch(RosterActions.postUserTrigger(CurrentUser.get().id, params))
    },
    fetchRosterData: () => {
      var clearUsers = props.mergeType == ADMIN_MERGE_TYPE ? dispatch(RosterActions.clearAdmins({})) : dispatch(RosterActions.clearStudents({}))
      var rosterRefresh = dispatch(RosterActions.fetchRosterData({}))
      return Promise.all([clearUsers, rosterRefresh]);
    },
  })
)
@providePopulateData({ waitForLoad: true })
class MergeUsersForm extends React.Component {
  constructor(props) {
    super();
    autobind(this);


    this.state = {
      chunked_users: [],
      idMapping: [],
      ignoreSuggestion: [],
      overrideMerge: [],
      loading: false,
      page: 1
    }
  }

  ///////// HELPERS /////////
  buildPageConfirm(pageMap) {
    var confirmText = 'Are you sure you want to merge the following users:\n'
    _.each(_.keys(pageMap), dupUserId => {
      var dupUser = _.findWhere(this.props.duplicateUsers, { id: parseInt(dupUserId) })
      var cleverUser = _.findWhere(this.props.users, { id: pageMap[dupUserId] })
      confirmText += `${dupUser.first_name} ${dupUser.last_name} (ID: ${dupUser.id}) `
      confirmText += `==> ${cleverUser.first_name} ${cleverUser.last_name} (ID: ${cleverUser.id})\n`
    })
    return confirmText
  }

  dupUserSearch(userID) {
    var { duplicateUsers } = this.props
    var userMap = this.userMapSearch(userID)
    if (userMap) {
      return _.findWhere(duplicateUsers, { id: userMap.dup_user_id })
    }
  }

  userMapSearch(userID) {
    return _.findWhere(this.state.idMapping, { user_id: userID })
  }

  dropdownValue(user) {
    if (!_.isEmpty(this.userMapSearch(user.id))) {
      var dupUser = this.dupUserSearch(user.id)
      var grade = ""
      if (user.grade) {
        grade = user.grade
      } else if (user.grade_level) {
        grade = user.grade_level
      }
      return { value: dupUser.id, label: `${dupUser.first_name} ${dupUser.last_name} ${grade} (ID: ${dupUser.id})` }
    } else {
      return { value: 0, label: 'No Match' }
    }
  }

  suggestionMatches(user) {
    return _.filter(this.props.duplicateUsers, (dupUser) => { return user.link_suggestion == dupUser.id })
  }

  showSuggestion(user) {
    return !_.isEmpty(this.suggestionMatches(user)) && !_.include(_.pluck(this.state.ignoreSuggestion, 'user_id'), user.id)
  }

  getLinkSuggestion(user) {
    if (!_.include(_.pluck(this.state.ignoreSuggestion, 'user_id'), user.id)) {
      return _.findWhere(this.props.duplicateUsers, { id: user.link_suggestion })
    }
  }

  formatMappingHash() {
    // format mapping hash for l2e
    // from_user_id: to_user_id
    var idMapping = {}
    _.each([...this.state.idMapping], (map) => { idMapping[map.dup_user_id] = map.user_id })

    // add suggestions that were confirmed
    var index = 0
    _.each(this.props.users, (user) => {
      index += 1
      if (this.getLinkSuggestion(user)) {
        idMapping[this.getLinkSuggestion(user).id] = user.id
      }
    })

    if (index == _.size(this.props.users)) {
      return idMapping
    }
  }

  dropdownOptions(user) {
    var { duplicateUsers, users, mergeType } = this.props
    
    // if clever merge, filter dropdown by duplicate users that
    // are not already merged with clever users
    if (mergeType == CLEVER_MERGE_TYPE) {
      duplicateUsers = _.filter(duplicateUsers, (dupUser) => {
        return _.isEmpty(_.where(users, { user_id: dupUser.id }))
      })
    }

    // filter dropdown options based on user type
    if (this.isDistrictAdmin(user)) {
      duplicateUsers = _.filter(duplicateUsers, (dupUser) => { return this.isDistrictAdmin(dupUser) })
    } else if (this.isSchoolAdmin(user)) {
      duplicateUsers = _.filter(duplicateUsers, (dupUser) => { return this.isSchoolAdmin(dupUser) })
    } else if (this.isTeacher(user)) {
      duplicateUsers = _.filter(duplicateUsers, (dupUser) => { return this.isTeacher(dupUser) })
    } else if (this.isStudent(user)) {
      duplicateUsers = _.filter(duplicateUsers, (dupUser) => { return this.isStudent(dupUser) })
    }

    // remove duplicate user
    duplicateUsers = _.uniq(duplicateUsers, (dupUser) => { return dupUser.id })

    return _.map(duplicateUsers, (dupUser) => {
      var grade = ""
      if (dupUser.grade) {
        grade = dupUser.grade
      } else if (dupUser.grade_level) {
        grade = dupUser.grade_level
      }

      return { value: dupUser.id, label: `${dupUser.first_name} ${dupUser.last_name} ${grade} (ID: ${dupUser.id})` }
    })
  }

  totalUserCount() {
    return _.size(this.props.users)
  }

  sortedUsers() {
    return _.sortBy(this.props.users, (user) => {

      var linkStrengthIndex = 0
      var mergeStrenghtIndex = 0

      // IF NO USER MERGED
      if (user.user_id == null) {
        var suggestion = this.getLinkSuggestion(user)

        if (suggestion) {
          linkStrengthIndex = 1
          const strength = this.getMatchStrength(user, suggestion)

          if (strength == "partial") {
            linkStrengthIndex = 2
          } else if (strength == "perfect") {
            linkStrengthIndex = 3
          }
        }
      } else { // IF USER MERGED
        var suggestion = this.mergedCleverUser(user)
        if (suggestion) {
          mergeStrenghtIndex = 1
          const strength = this.getMatchStrength(user, suggestion)

          if (strength == "partial") {
            mergeStrenghtIndex = 2
          } else if (strength == "perfect") {
            mergeStrenghtIndex = 3
          }
        } else {
          mergeStrenghtIndex = 0
        }
      }
      // PLACE WEAK LINK AND MERGE FIRST
      return [user.grade, mergeStrenghtIndex, linkStrengthIndex, user.last_name, user.first_name].join("_")
    })
  }
  // chunk users in state for pagination
  getPerPage() {
    if (this.props.mergeType == CLEVER_MERGE_TYPE) {
      return 20
    }
    return PER_PAGE
  }
  chunkUsers() {
    this.setState({ chunked_users: _.chunk(this.sortedUsers(), this.getPerPage()) })
  }
  // return dup user that is merged with a clever user or false
  mergedCleverUser(user) {
    if (user.user_id && // user id exists
      _.size(this.props.duplicateUsers) && // duplicate users exist
      !_.findWhere(this.state.overrideMerge, { user_id: user.id }) && // user is not overrriden
      this.props.mergeType == CLEVER_MERGE_TYPE) { // merge type is correct
      return _.findWhere(this.props.duplicateUsers, { id: user.user_id })
    } else {
      return false
    }
  }
  // places suggestion in map automatically
  addSuggestionsToMap() {
    var newMap = [...this.state.idMapping]

    var index = 0
    _.each(this.props.users, (user) => {
      index += 1
      if (this.getLinkSuggestion(user) && !this.mergedCleverUser(user)) {
        var existingMap = _.findWhere(newMap, { user_id: user.id })
        if (existingMap) {
          newMap = _.filter(newMap, (map) => { return map.user_id != user.id })
        }
        newMap = [...newMap, { user_id: user.id, dup_user_id: this.getLinkSuggestion(user).id }]
      }
    })

    if (index == _.size(this.props.users)) {
      this.setState({ idMapping: newMap })
    }
  }

  isDistrictAdmin(user) {
    return _.includes(DISTRICT_ADMIN_ROLES, user.role)
  }

  isSchoolAdmin(user) {
    return _.includes(SCHOOL_ADMIN_ROLES, user.role)
  }

  isTeacher(user) {
    return _.includes(TEACHER_ROLES, user.role)
  }

  isStudent(user) {
    return _.includes(STUDENT_ROLES, user.role)
  }
  //////////////////////////

  //// SUBMIT HANDLER /////
  onSubmitSingle(suggestionId, cleverUserId) {
    var idMapping = {}
    idMapping[suggestionId] = cleverUserId

    var params = {
      what: "merge_users",
      mapping: idMapping,
      merge_type: this.props.mergeType
    }

    this.props.mergeUsers(params).then((response) => {
      if (response.success) {
        window.wrNotifications.triggerDropDownNotification({
          title: "Success!", text: "Users have been merged with this account", icon: "ok-sign"
        });
        // UPDATE CLEVER USER IN PARENT COMPONENT
        this.props.afterSubmit(suggestionId, cleverUserId)
      } else {
        this.setState({ loading: false })
        // error message
        window.wrNotifications.triggerDropDownNotification({
          title: "Oops!", text: "Something went wrong and the users were not merged",
          type: "error", icon: "exclamation-sign"
        }, 4000);
      }
    })
  }

  onPageSubmit() {
    var { page, chunked_users } = this.state
    var cleverUsers = chunked_users[page - 1]

    var masterMap = this.formatMappingHash()
    // pull current page from master map
    var pageMap = {}
    _.each(cleverUsers, cUser => {
      if (_.includes(_.values(masterMap), cUser.id)) {
        var dupUserId = Object.keys(masterMap).find(key => masterMap[key] === cUser.id);
        pageMap[dupUserId] = cUser.id
      }
    })

    if (confirm(this.buildPageConfirm(pageMap))) {
      var params = {
        what: "merge_users",
        mapping: pageMap,
        merge_type: this.props.mergeType
      }

      this.props.mergeUsers(params).then((response) => {
        if (response.success) {
          window.wrNotifications.triggerDropDownNotification({
            title: "Success!", text: "Users have been merged with this account", icon: "ok-sign"
          });
          // UPDATE CLEVER USER IN PARENT COMPONENT
          _.each(_.keys(pageMap), suggestionId => {
            this.props.afterSubmit(parseInt(suggestionId), pageMap[suggestionId])
          })
        } else {
          this.setState({ loading: false })
          // error message
          window.wrNotifications.triggerDropDownNotification({
            title: "Oops!", text: "Something went wrong and the users were not merged",
            type: "error", icon: "exclamation-sign"
          }, 4000);
        }
      })
    }
  }

  onSubmit() {

    this.setState({ loading: true })
    var idMapping = this.formatMappingHash()

    // merge users
    var params = {
      what: "merge_users",
      mapping: idMapping,
      merge_type: this.props.mergeType
    }

    this.props.mergeUsers(params).then((response) => {
      if (response.success) {
        // refresh users
        this.props.fetchRosterData().then(() => {
          // success message
          window.wrNotifications.triggerDropDownNotification({
            title: "Success!", text: "Users have been merged with this account", icon: "ok-sign"
          });
          // post submit method
          if (this.props.afterSubmit) {
            this.props.afterSubmit()
          }
          this.setState({ loading: false })
        })
      } else {
        this.setState({ loading: false })
        // error message
        window.wrNotifications.triggerDropDownNotification({
          title: "Oops!", text: "Something went wrong and the users were not merged",
          type: "error", icon: "exclamation-sign"
        }, 4000);
      }
    })
  }
  //////////////////////////

  ///// EVENT HANDLERS /////
  handleDuplicateDropdownClick(user, dupUserID) {

    if (!_.isEmpty(this.userMapSearch(user.id)) && this.userMapSearch(user.id).dup_user_id == dupUserID) {
      // selects previously-selected dup user
      var newIDMap = _.filter([...this.state.idMapping], (map) => { return map.user_id != user.id })
    } else if (!_.isEmpty(this.userMapSearch(user.id))) {
      // updateds duplicate user selection
      var newIDMap = _.filter([...this.state.idMapping], (map) => { return map.user_id != user.id })
      newIDMap = [...newIDMap, { user_id: user.id, dup_user_id: dupUserID }]
    } else {
      // new duplicate user selection
      var newIDMap = [...this.state.idMapping, { user_id: user.id, dup_user_id: dupUserID }]
    }

    // check if dupUser is selected for a different user
    var dupUserMap = _.findWhere(newIDMap, { dup_user_id: dupUserID })
    if (dupUserMap && dupUserMap.user_id !== user.id) {
      newIDMap = _.filter(newIDMap, (map) => { return map.dup_user_id != dupUserID })
      newIDMap = [...newIDMap, { user_id: user.id, dup_user_id: dupUserID }]
    }

    // check if the dup_user is a current suggestion
    var ignoreSuggestion = [...this.state.ignoreSuggestion]
    var linkSuggestion = _.findWhere(this.props.users, { link_suggestion: dupUserID })
    if (linkSuggestion) {
      ignoreSuggestion = _.filter(ignoreSuggestion, (suggestion) => { return suggestion.dup_user_id != dupUserID })
      ignoreSuggestion = [...ignoreSuggestion, { user_id: linkSuggestion.id, dup_user_id: dupUserID }]
    }

    this.setState({ idMapping: newIDMap, ignoreSuggestion })
  }

  handleChangeSuggestion(dupUserID, userID) {
    this.setState({ ignoreSuggestion: [...this.state.ignoreSuggestion, { dup_user_id: dupUserID, user_id: userID }] })
  }

  handleChangeMerge(dupUserID, userID) {
    this.setState({ overrideMerge: [...this.state.overrideMerge, { dup_user_id: dupUserID, user_id: userID }] })
  }
  onPageChange(page) {
    this.setState({ page });
  }
  //////////////////////////

  /// RENDER FUNCTIONS ////
  renderLoadingBtn() {
    if (this.props.mergeType == CLEVER_MERGE_TYPE) { 
      return (
        <div className="btnContainer">
          <LoadingButton loading={this.state.loading} text={'Submit Page'}
            className="btn buttonPrimary submitLink"
            onClick={() => this.onPageSubmit()} />
        </div>
      )
    } else {
      return (
        <div className="btnContainer">
          <LoadingButton loading={this.state.loading} text={'Submit'}
            className="btn buttonPrimary submitLink"
            onClick={() => this.onSubmit()} />
        </div>
      )
    }
  }

  renderPagination() {

    return (
      <div className="paginationControlls">
        <PaginationControls page={this.state.page}
          perPage={this.getPerPage()}
          totalCount={this.totalUserCount()}
          onPageChange={this.onPageChange} />
      </div>
    )
  }

  renderConfirmChange(userID, cleverUserID) {
    return <a onClick={() => this.onSubmitSingle(userID, cleverUserID)} className="changeSuggestion">confirm</a>
  }

  renderChangeSuggestion(suggestion, user) {
    return <a onClick={() => this.handleChangeSuggestion(suggestion.id, user.id)} className="changeSuggestion">change</a>
  }

  renderDuplicateUserDropdown(user) {
    var dupUserSelection = this.dupUserSearch(user.id)
    if (dupUserSelection) {
      var confirmChange = this.renderConfirmChange(dupUserSelection.id, user.id)
      console.log(dupUserSelection, user)
      var suggestions = this.renderAllSuggestions(user, false)
    }
      
    return (
      <span>
        <div className='duplicateUsersDropdown'>
          <ReactSelect
            clearable={false}
            value={this.dropdownValue(user)}
            options={this.dropdownOptions(user)}
            onChange={(opt) => this.handleDuplicateDropdownClick(user, opt.value)} />
          {confirmChange}
        </div>
        {suggestions}
      </span>
    )
  }

  getMatchStrength(user, suggestion) {
    if (user == undefined || suggestion == undefined) {
      return ""
    }

    if (user.first_name.toLowerCase() == suggestion.first_name.toLowerCase() && user.last_name.toLowerCase() == suggestion.last_name.toLowerCase()){
      return "perfect"
    } else if (user.first_name.toLowerCase() == suggestion.first_name.toLowerCase() || user.last_name.toLowerCase() == suggestion.last_name.toLowerCase()){
      return "partial"
    } else {
      return "weak"
    }
  }

  renderAllSuggestions(user, ignoreTopSuggestion) {
    if (_.size(user.all_link_suggestions) > 1) {
      var intro = ignoreTopSuggestion ? 'Other Suggestions: ' : 'All Suggestions: '
      return (
        <div className="otherSuggestions">
          {intro}{_.map(user.all_link_suggestions, (otherSuggestionID, idx) => {
            if (!ignoreTopSuggestion || otherSuggestionID != user.link_suggestion) {
              var otherSuggestion = _.findWhere(this.props.duplicateUsers, { id: user.link_suggestion })
              var content = `${otherSuggestion.first_name} ${otherSuggestion.last_name} (${otherSuggestionID})`
              if (idx !== _.size(user.all_link_suggestions) - 1) {
                content = content + ', '
              }
              return <span>{content}</span>
            }
          })}
        </div>
      )
    } 
  }
  renderSuggestion(user) {
    var suggestion = this.getLinkSuggestion(user)
    var colorCode = this.getMatchStrength(user, suggestion) + "Match"

    return (
      <div className="suggestionContainer">
        <div className="suggestionRow">
          <div className={`column one ${colorCode}`} style={{ width: '80%' }}>{`${suggestion.first_name} ${suggestion.last_name}`} <br /> {`grade: ${suggestion.grade_level} (ID: ${suggestion.id})`}</div>
          <div className="column two" style={{ width: '20%' }}>{this.renderConfirmChange(suggestion.id, user.id)}</div>
        </div>
        <div className="suggestionRow">
          <div className="column one" style={{ width: '80%' }}>{this.renderAllSuggestions(user, true)}</div>
          <div className="column two" style={{ width: '20%' }}>{this.renderChangeSuggestion(suggestion, user)}</div>
        </div>
      </div>
    )
  }

  renderMergeOutsideSchool(user) {
    return (
      <div className="mergeContainer">
        <div className='merge warning'>
          Merged With User Outside of School Org: (ID: {user.user_id})
        </div>
      </div>
    )
  }

  renderMergedUser(user) {
    var mergedUser = this.mergedCleverUser(user)
    var colorCode = this.getMatchStrength(user, mergedUser) + "Merge"

    return (
      <div className="mergeContainer">
        <div className={"merge " + colorCode}>
          Merged With {`${mergedUser.first_name} ${mergedUser.last_name}`} <br/> {`grade: ${mergedUser.grade_level} (ID: ${mergedUser.id})`}
        </div>
      </div>
    )
  }

  renderColumnHeaders() {
    if (this.props.mergeType == STUDENT_MERGE_TYPE) {
      return (
        <div className="labelRow">
          <div className="userListLabel">Users from this account</div>
          <div className="dupUserListLabel">Users from merged account</div>
        </div>
      )
    }
  }

  pendingText() {
    var { duplicateUsers, mergeType } = this.props
    if (mergeType == CLEVER_MERGE_TYPE) {
      if (_.isEmpty(duplicateUsers)) {
        return (
          <div>Duplicate users loading...</div>
        )
      }
    }
  }

  renderRows() {
    var { chunked_users, page } = this.state
    var users = chunked_users[page - 1]
    return _.map(users, (user, index) => {
      // renders suggestion, merge, or dropdown
      if (this.mergedCleverUser(user)) {
        var dupUserColumn = this.renderMergedUser(user)
      } else if (this.getLinkSuggestion(user)) {
        var dupUserColumn = this.renderSuggestion(user)
      } else if (user.user_id) {
        var dupUserColumn = this.renderMergeOutsideSchool(user)
      } else {
        var dupUserColumn = this.renderDuplicateUserDropdown(user)
      }
      var borderClass = index == _.size(users) - 1 ? '' : 'borderBottom'

      return (
        <div className={`userRow ${borderClass}`} key={'user-' + user.id}>
          <div className='userColumn'>
            {`${user.first_name} ${user.last_name}`} <br/> {`grade: ${user.grade} (ID: ${user.id})`}
          </div>
          <div className="duplicateUsersColumn">
            {dupUserColumn}
          </div>
        </div>
      )
    })
  }
  //////////////////////////

  render() {
    if (this.state.loading) {
      return <Spinner placeholder={true} scale={1.7} />
    } else {
      return (
        <div className="mergeUserForm">
          {this.renderColumnHeaders()}
          {this.pendingText()}
          <div className="usersList">
            {this.renderRows()}
          </div>
          {this.renderPagination()}
          { this.renderLoadingBtn() }
        </div>
      )
    }
  }

  componentDidMount() {
    this.chunkUsers()
    this.addSuggestionsToMap()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.users !== this.props.users) {
      this.chunkUsers()
      this.addSuggestionsToMap()
    }
  }
}

var ADMIN_MERGE_TYPE = "admin";
var STUDENT_MERGE_TYPE = "student";
var CLEVER_MERGE_TYPE = 'clever'
var PER_PAGE = 10

var STUDENT_ROLE = "studentRole"
var TEACHER_ROLE = "teacherRole"
var SCHOOL_ADMIN_ROLE = "adminRole"
var DISTRICT_ADMIN_ROLE = "districtAdminRole"

var CLEVER_STUDENT_ROLE = "student"
var CLEVER_TEACHER_ROLE = "teacher"
var CLEVER_SCHOOL_ADMIN_ROLE = "school_admin"
var CLEVER_DISTRICT_ADMIN_ROLE = "district_admin"

var DISTRICT_ADMIN_ROLES = [DISTRICT_ADMIN_ROLE, CLEVER_DISTRICT_ADMIN_ROLE]
var SCHOOL_ADMIN_ROLES = [SCHOOL_ADMIN_ROLE, CLEVER_SCHOOL_ADMIN_ROLE]
var TEACHER_ROLES = [TEACHER_ROLE, CLEVER_TEACHER_ROLE]
var STUDENT_ROLES = [STUDENT_ROLE, CLEVER_STUDENT_ROLE]

MergeUsersForm.WrappedComponent.propTypes = PageStrictPropTypes({
  userIDs: PropTypes.array,
  duplicateUserIDs: PropTypes.array,
  mergeType: PropTypes.string,
  studentListIDs: PropTypes.array,
  duplicateUsers: PropTypes.array,
  users: PropTypes.array,
  cleverUsers: PropTypes.array,

  populateData: PropTypes.func.isRequired,
  mergeUsers: PropTypes.func,
  afterSubmit: PropTypes.func,
  fetchRosterData: PropTypes.func,
})

module.exports = MergeUsersForm;


// WEBPACK FOOTER //
// ./modules/components/users/shared/MergeUsersForm.js